import { observer } from "mobx-react";
import { useEffect } from "react";
import useValidations from "../../hooks/useValidations";
import { SendToBillingStore as Store } from "../../store";
import FormIntegration from "../Contract/ContractForm/FormIntegration";

/** Formulário com os dados de integração a serem preenchidos para o
 * processo de enviar medição para faturamento.
 */
const FormIntegrationToBilling = observer(() => {
  const data = Store.integrationData;
  const { validated, validateFields } = useValidations({
    client: "required",
    branch: "required",
    paymentCondition: "required",
    documentType: "required",
    costCenter: "required",
    projectErp: "required",
  });

  useEffect(() => {
    const isValid =
      data.client &&
      data.branch &&
      data.paymentCondition &&
      data.documentType &&
      data.costCenter &&
      data.projectErp;
    Store.setIntegrationHasError(!isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (name, value) => {
    Store.setIntegrationData(name, value);
    if (name === "documentType") Store.getProductsItemsData(value?.id);
    if (name === "branch") Store.getCitiesItemsData(value?.agentId);
  };

  const handleBlur = (ev) => {
    const { name, value } = ev.target;
    const allValid = validateFields({ [name]: value });
    Store.setIntegrationHasError(!allValid);
  };

  return (
    <FormIntegration
      data={data}
      validated={validated}
      allRequired={true}
      showIndicators={false}
      onInputChange={handleChange}
      onInputBlur={handleBlur}
    />
  );
});

export default FormIntegrationToBilling;
